import React, { useEffect, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { makeStyles } from '@mui/styles';
import GitInfo from 'react-git-info/macro';
import { useSnackbar } from 'notistack';
import { setApiVersion } from '@/common/utils/api';

import AuthUserStore from '@/common/utils/AuthUser';

const useStyles: any = makeStyles(() => ({
  root: {
    position: 'absolute'
  },
  version: {
    padding: '0px 20px 0px 16px',
    display: 'block',
    fontWeight: 500,
    '& < div': {
      marginBottom: 8
    }
  },
  versionLinks: {
    display: 'block',
    color: '#999999',
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 1.5,
    '& p': {
      display: 'block'
    }
  }
}));

const formatVersion = version => {
  if (!version) {
    return '';
  }
  return version.replace('release/', 'r');
};

const StackVersions = ({ showLabel = true }) => {
  const classes = useStyles();
  const uiGitInfo = GitInfo();
  const [BEBuildVersion, setBEBuildVersion] = useState(
    formatVersion(AuthUserStore.getBuildVersion())
  );
  const { enqueueSnackbar } = useSnackbar();

  const onCopy = Layer => {
    enqueueSnackbar(`${Layer} commit hash copied to clipboard`, {
      variant: 'success',
      autoHideDuration: 1000
    });
  };

  const fetchVersion = async () => {
    const version = await setApiVersion();
    setBEBuildVersion(formatVersion(version));
  };

  useEffect(() => {
    fetchVersion();
  }, []);

  return (
    <div className={classes.version}>
      {showLabel && 'Versions:'}
      <CopyToClipboard
        text={uiGitInfo.commit.shortHash}
        onCopy={() => onCopy('UI')}
      >
        <div className={classes.versionLinks}>
          UI: &nbsp;
          {`${uiGitInfo.commit.shortHash}`}
        </div>
      </CopyToClipboard>
      <CopyToClipboard text={BEBuildVersion} onCopy={() => onCopy('API')}>
        <div className={classes.versionLinks}>
          API:&nbsp; {`${BEBuildVersion}`}
        </div>
      </CopyToClipboard>
    </div>
  );
};

export default StackVersions;
